import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ErrorHandlerService } from '../Services/error-handler.service';
import { Router } from '@angular/router';
import { AuthTokenService } from '../Services/auth-token.service';
import { AccessDecisionRouterService } from '../Services/access-decision-router.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorHandler = inject(ErrorHandlerService);
  const authTokenService = inject(AuthTokenService);
  const accessDecisionRouter = inject(AccessDecisionRouterService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
          authTokenService.setReturnUrl(router.url);
        }

        if (accessDecisionRouter.redirectOnDenial(error)) {
          return throwError(() => error);
        }

        errorHandler.handleError(error);
      }
      return throwError(() => error);
    })
  );
};
